import axios from "axios";
import { Component } from 'react';
import { Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import DatePicker from 'react-datepicker';
import { validateProjectForm } from '../../utils/validation';
import CommonLoader from '../loaderComponent/CommonLoader';
import CommonToast from '../Toaster/CommonToast';

export default class AddProject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      customerId: "",
      startDate: null,
      endDate: null,
      targetDate: null,
      description: "",
      employeeList: [],
      status: "",
      customers: [],
      vendors: [],
      loading: true,
      hasError: false,
      errMsg: "",
      completed: false,
      message: '',
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
      projectDetailsData: this.props.location.state?.data
    };
  }

  async componentDidMount() {
    this.setState({ loading: true });
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    const { projectDetailsData } = this.state || {};
    console.log("data conning from edit button", projectDetailsData);
    if (projectDetailsData) {
      this.setState({
        name: projectDetailsData.name,
        customerId: projectDetailsData.customerId,
        startDate: projectDetailsData.start_date ? new Date(projectDetailsData.start_date) : null,
        targetDate: projectDetailsData.target_date ? new Date(projectDetailsData.target_date) : null,
        endDate: projectDetailsData.end_date ? new Date(projectDetailsData.end_date) : null,
        status: projectDetailsData.status,
        description: projectDetailsData.description,
        projectDetailsData,
      });
    }

    try {
      const [customersRes, vendorsRes] = await Promise.all([
        axios.get('/customer', { headers }),
      ]);
      const activeCustomers = customersRes.data.filter(customer => customer.status.toLowerCase() === 'active');
      this.setState({
        customers: activeCustomers,
      });
      const usersResponse = await axios.get("/users", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      console.log("Users Response:", usersResponse);
      this.setState({ employeeList: usersResponse.data, loading: false });
    } catch (error) {
      console.error("Error fetching data:", error);
      this.setState({ hasError: true, errMsg: "Failed to load customers" });
      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
        this.props.history.push('/login');
      }, 900);

    }
  }

  handleChange = (event) => {
    const { value, name } = event.target;
    let errors = { ...this.state.errors };
    if (value.trim()) {
      delete errors[name];
    }
    this.setState({
      [name]: value,
      errors
    });
  };

  handleDateChange = (date, field) => {
    if (!date) return;

    const normalizedDate = new Date(date);
    normalizedDate.setHours(0, 0, 0, 0);

    let errors = { ...this.state.errors };

    if (field === "startDate") {
      this.setState({
        startDate: normalizedDate,
        targetDate: normalizedDate,
        endDate: null,
        errors: { ...errors, startDate: undefined },
      });
    }

    if (field === "targetDate") {
      if (normalizedDate < this.state.startDate) {
        errors.targetDate = "Target date cannot be before Start Date.";
      } else {
        delete errors.targetDate;
      }

      this.setState({
        targetDate: normalizedDate,
        endDate: null,
        errors,
      });
    }

    if (field === "endDate") {
      if (normalizedDate < this.state.targetDate) {
        errors.endDate = "End date must be on or after Target Date.";
      } else {
        delete errors.endDate;
      }
      this.setState({
        endDate: normalizedDate,
        errors,
      });
    }
  };

  formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = (`0${d.getMonth() + 1}`).slice(-2); // ensures 2-digit month
    const day = (`0${d.getDate()}`).slice(-2);        // ensures 2-digit day
    return `${year}-${month}-${day}`;
  };


  onSubmit = async (e) => {
    // debugger
    this.setState({ loading: true });
    e.preventDefault();
    const { name, customerId, description, startDate, targetDate, endDate, status } = this.state;
    const errors = validateProjectForm(
      name, customerId, description, startDate, targetDate, endDate, status
    );
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    const projectData = {
      name: this.state.name,
      customerId: this.state.customerId,
      start_date: this.formatDate(this.state.startDate),
      end_date: this.formatDate(this.state.endDate),
      target_date: this.formatDate(this.state.targetDate),
      status: this.state.status,
      description: this.state.description || null
    };
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }
    try {
      console.log("add  case", projectData);
      const { projectDetailsData } = this.state || {};
      let projectStatusResponse;
      // await axios.post('/project', projectData, { headers });
      if (projectDetailsData && projectDetailsData.id) {
        projectStatusResponse = await axios.put(`/project/${projectDetailsData.id}`, projectData, { headers });
      } else {
        projectStatusResponse = await axios.post('/project', projectData, { headers });
      }

      this.setState({
        completed: true,
        toastMessage: projectStatusResponse?.data?.message ? projectStatusResponse?.data?.message : 'Project Created successfully!',
        toastVariant: 'success',
        color: 'green',
        showToast: true,
      });
      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
        this.props.history.push("/project-list");
      }, 900);
    } catch (error) {
      if (error.response) {
        console.error('Error response from server:', error.response.data);
        const errorMessage = error.response.data.error;
        if (errorMessage === "A project with the same name and customer already exists.") {
          this.setState({
            hasError: true,
            errMsg: errorMessage,
            toastMessage: "Project not created!",
            toastVariant: 'danger',
            color: 'red',
            showToast: true,
          });
          setTimeout(() => {
            this.setState({ loading: false, showToast: false });
          }, 900);
        } else if (errorMessage === "A project with the same name already exists. Please enter a new name.") {
          this.setState({
            hasError: true,
            errMsg: errorMessage,
            toastMessage: "Project not created!",
            toastVariant: 'danger',
            color: 'red',
            showToast: true,
          });
          setTimeout(() => {
            this.setState({ loading: false, showToast: false });
          }, 900);
        }
        else {
          this.setState({
            hasError: true,
            errMsg: errorMessage,
            toastMessage: "Failed to create project!",
            toastVariant: 'danger',
            color: 'red',
            showToast: true,
          });
          setTimeout(() => {
            this.setState({ loading: false, showToast: false });
          }, 900);
        }
      } else {
        console.error('Error creating project:', error.message);
        this.setState({ hasError: true, errMsg: "An unexpected error occurred." });
        setTimeout(() => {
          this.setState({ loading: false, showToast: false });
        }, 900);
      }
    }

  };

  handleBack = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.props.history.push("/project-list");
      this.setState({ loading: false });
    }, 500);
  };

  render() {
    return (
      <div className="pt-4">
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={this.state.loading}>
          < >
            <Card className="shadow-sm rounded border-0">
              <Card.Header className="text-white">
                <strong>{this.state.projectDetailsData?.id ? "Update Project" : 'Add Project'}</strong>
              </Card.Header>
              <Card.Body>
                {this.state.loading ? (
                  <div className="text-center">
                    <Spinner animation="border" variant="outline-primary" className="loader" />
                  </div>
                ) : (
                  <Form onSubmit={this.onSubmit}>

                    <Row className="mb-3">
                      <Col xs={12} md={3} lg={3}>
                        <Form.Group>
                          <Form.Label className="text-muted required">Project Name</Form.Label>
                          <Form.Control type="text" name="name" size="md" value={this.state.name} onChange={this.handleChange}
                            placeholder='Enter project name'
                          />
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.name && <small className="text-danger">{this.state.errors.name}</small>}
                        </span>
                      </Col>
                      <Col xs={12} md={3} lg={3}>
                        <Form.Group>
                          <Form.Label className="text-muted required">Customer</Form.Label>
                          <Form.Control as="select" className="form-select" name="customerId" value={this.state.customerId} onChange={this.handleChange} >
                            <option value="" disabled>Select customer</option>
                            {this.state.customers.map(customer => (
                              <option key={customer.id} value={customer.id}>{customer.name}</option>
                            ))}
                          </Form.Control>
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.customerId && <small className="text-danger">{this.state.errors.customerId}</small>}
                        </span>
                      </Col>
                      <Col xs={12} md={3} lg={3}>
                        <Form.Group>
                          <Form.Label className="text-muted required">Start Date </Form.Label><br />
                          <DatePicker
                            selected={this.state.startDate}
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            onChange={date => this.handleDateChange(date, 'startDate')}
                            placeholderText="Select start date"
                            minDate={new Date(new Date().getFullYear(), new Date().getMonth(), 1)}
                          />
                          <span className="login-error">
                            {this.state.errors.startDate && <small className="text-danger">{this.state.errors.startDate}</small>}
                          </span>
                        </Form.Group>
                      </Col>
                      <Col xs={12} md={3} lg={3}>
                        <Form.Group>
                          <Form.Label className="text-muted required">Target Date</Form.Label><br />
                          <DatePicker
                            selected={this.state.targetDate}
                            className="form-control"
                            onChange={date => this.handleDateChange(date, 'targetDate')}
                            placeholderText="Select target date"
                            dateFormat="dd/MM/yyyy"
                            minDate={this.state.startDate || new Date()}
                            disabled={!this.state.startDate}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                          />
                          <span className="login-error">
                            {this.state.errors.targetDate && <small className="text-danger">{this.state.errors.targetDate}</small>}
                          </span>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col xs={12} md={3} lg={3}>
                        <Form.Group>
                          <Form.Label className="text-muted ">End Date</Form.Label><br />
                          <DatePicker
                            selected={this.state.endDate}
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            onChange={date => this.handleDateChange(date, 'endDate')}
                            placeholderText="Select end date"
                            minDate={this.state.targetDate || this.state.startDate}
                            // disabled={!this.state.startDate || !this.state.targetDate}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                          />
                          <span className="login-error">
                            {this.state.errors.endDate && <small className="text-danger">{this.state.errors.endDate}</small>}
                          </span>
                        </Form.Group>
                      </Col>
                      <Col xs={12} md={3} lg={3}>
                        <Form.Group>
                          <Form.Label className="text-muted required">Status</Form.Label>
                          <Form.Control as="select" className="form-select" name="status" value={this.state.status} onChange={this.handleChange} >
                            <option value="" disabled>Select Status</option>
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                          </Form.Control>
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.status && <small className="text-danger">{this.state.errors.status}</small>}
                        </span>
                      </Col>
                      <Col xs={12} md={6} lg={6}>
                        <Form.Group>
                          <Form.Label className="text-muted">Description</Form.Label>
                          <Form.Control as="textarea" rows={1} name="description" value={this.state.description} onChange={this.handleChange}
                            placeholder='Enter description'
                          />
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.description && <small className="text-danger">{this.state.errors.description}</small>}
                        </span>
                      </Col>

                    </Row>

                    <div className='add-cancel-btn '>
                      <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" type="submit" >
                        {this.state.projectDetailsData?.id ? "Update" : "Add"}
                      </Button>
                      <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" onClick={this.handleBack}>Cancel</Button>
                    </div>
                  </Form>
                )}
              </Card.Body>
            </Card>
          </>
        </CommonLoader >
      </div >
    );
  }
}
